import { STATE_STATUS } from '@mgCommon/constants/constants.js';
import TemplatesService from '@mgServices/templates.service.js';
import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';

const initialState = {
  templates: [],
  selectedTemplate: {},
  messageContent: '',
  proofingMessage: '',
  status: STATE_STATUS.IDLE,
  error: null,
};

export const getTemplatesByCategory = createAsyncThunk('templates/getByCategory', async ({ category = null }) => {
  const res = await TemplatesService.getByCategory({ category });
  return res.data;
});

export const createTemplate = createAsyncThunk('templates/create', async ({ template = null, category = null }) => {
  const res = await TemplatesService.create({ template, category });
  return res.data;
});

export const updateTemplate = createAsyncThunk(
  'templates/update',
  async ({ id = null, template = null, category = null }) => {
    const res = await TemplatesService.update({ id, template, category });
    return {
      id,
      template: res.data,
    };
  }
);

export const deleteTemplate = createAsyncThunk('templates/delete', async ({ id = null, category = null }) => {
  const res = await TemplatesService.delete({ id, category });
  return {
    id,
    template: res.data,
  };
});

const templatesSlice = createSlice({
  name: 'templates',
  initialState,
  reducers: {
    setSelectedTemplate(state, { payload }) {
      state.selectedTemplate = payload.selectedTemplate;
    },
    setMessageContent(state, { payload }) {
      state.messageContent = payload.messageContent;
    },
    setProofingMessage(state, { payload }) {
      state.proofingMessage = payload.proofingMessage;
    },
  },
  extraReducers: builder => {
    builder
      .addCase(getTemplatesByCategory.pending, state => {
        state.status = STATE_STATUS.LOADING;
      })
      .addCase(getTemplatesByCategory.fulfilled, (state, { payload }) => {
        state.templates = payload;
        state.status = STATE_STATUS.SUCCEEDED;
      })
      .addCase(getTemplatesByCategory.rejected, (state, { error }) => {
        state.status = STATE_STATUS.FAILED;
        state.error = error.message;
      })
      .addCase(createTemplate.pending, state => {
        state.status = STATE_STATUS.LOADING;
      })
      .addCase(createTemplate.fulfilled, (state, { payload }) => {
        state.templates.push(payload);
        state.status = STATE_STATUS.SUCCEEDED;
      })
      .addCase(createTemplate.rejected, (state, { error }) => {
        state.status = STATE_STATUS.FAILED;
        state.error = error.message;
      })
      .addCase(updateTemplate.pending, state => {
        state.status = STATE_STATUS.LOADING;
      })
      .addCase(updateTemplate.fulfilled, (state, { payload }) => {
        const index = state.templates.findIndex(t => t.id === payload.id);
        state.templates[index] = payload.template;
        state.status = STATE_STATUS.SUCCEEDED;
      })
      .addCase(updateTemplate.rejected, (state, { error }) => {
        state.status = STATE_STATUS.FAILED;
        state.error = error.message;
      })
      .addCase(deleteTemplate.pending, state => {
        state.status = STATE_STATUS.LOADING;
      })
      .addCase(deleteTemplate.fulfilled, (state, { payload }) => {
        const index = state.templates.findIndex(t => t.id === payload.id);
        state.templates.splice(index, 1);
        state.status = STATE_STATUS.SUCCEEDED;
      })
      .addCase(deleteTemplate.rejected, (state, { error }) => {
        state.status = STATE_STATUS.FAILED;
        state.error = error.message;
      });
  },
});

export const { setProofingMessage, setSelectedTemplate, setMessageContent } = templatesSlice.actions;
export default templatesSlice.reducer;
